require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-c-2-vsu-vph-ge-ww-k-6-ygvas-v-rcz.json") })
        }
      }, "path---careers-c-2-vsu-vph-ge-ww-k-6-ygvas-v-rcz");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-c-2-vsu-vph-ge-ww-k-6-ygvas-v-rcz!./.cache/json/careers-c-2-vsu-vph-ge-ww-k-6-ygvas-v-rcz.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---careers-c-2-vsu-vph-ge-ww-k-6-ygvas-v-rcz!./.cache/json/careers-c-2-vsu-vph-ge-ww-k-6-ygvas-v-rcz.json
// module chunks = 231608221292675